import { UserResponse } from '../py-generated/datalouder/third_party_login/types';
import useSelector from './useSelector';

export const useUser = (): UserResponse | undefined => {
  const { user } = useSelector(state => state.user);
  return user;
};

export const useMembership = (): boolean => {
  const user = useUser();
  return user?.hasMembership;
};
